import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'
import { instalarCaixaAlta } from './lib/uppercase'
import { instalarNavegacaoForms } from './lib/formNav'

// Tema global: ESCURO por padrão. Aplica .app-dark no <html> antes de renderizar
// (cobre login e todas as telas); o usuário troca pelo botão no topo (chave velore_tema).
try {
  const tema = localStorage.getItem('velore_tema') || 'escuro'
  if (tema !== 'claro') document.documentElement.classList.add('app-dark')
} catch {}

// CAIXA ALTA em todos os campos de texto (exceto e-mail/senha/url) — global.
instalarCaixaAlta()
// ENTER avança pro próximo campo + número seleciona ao focar (apaga o "0") — global.
instalarNavegacaoForms()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" toastOptions={{ style: { fontSize: 14 } }} />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
